import React from "react";
import { useTransactions } from "../hooks/useTransactions";
import { TransactionsTable } from "../components/TransactionsTable";
import { useAgreementContext } from "../AgreementContext";
import { Stack } from "@mui/material";

const TransactionsPage = () => {
  const agreement = useAgreementContext();
  const transactions = useTransactions(agreement.id);
  return (
    <Stack spacing={5} sx={{ px: 5, mb: 5 }}>
      <TransactionsTable agreement={agreement} {...transactions} />
    </Stack>
  );
};

export default TransactionsPage;
